import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

export interface Report {
	projectName: string;
	activityType: string;
	activityDuration: number;
	comments: string;
	activityDate: string;
	workDescription: string;
	reportId: string;
	email: string;
	picture: string;
	userName: string;
	workMode: string;
}


const initialState:any = [];

const monthlySummaryReducer = createSlice({
	name: 'monthlySummary',
	initialState,
	reducers: {
		setMonthlySummary: (state, action) => {
			state = action.payload;
			return state;
		},
		addMonthlySummary: (state, action) => {
			state = [action.payload,...state];
			return state;
		},
        updateMonthlySummary: (state, action) => {

			const indexOfReportToChange = state.findIndex((report:any) => report.reportId === action.payload.reportId);
			const changedReport = action.payload;

			state[indexOfReportToChange] = changedReport;
			return state;
		},
	},
	extraReducers(builder) {
		builder
			.addCase(revertAll, () => initialState);
	}
});

export const { setMonthlySummary,addMonthlySummary,updateMonthlySummary } = monthlySummaryReducer.actions;
export default monthlySummaryReducer;
